import { useState } from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

import { Routes } from '@share/constants';

import { RewardsHero } from '../rewards-hero';

import './style.scss';

interface IProps {
  accountName?: string;
}

export function RewardsQaContent(props: IProps) {
  const { accountName } = props;
  const rewardsPath = accountName ? `/${accountName}${Routes.Rewards}` : '#';
  const [openIds, setOpenIds] = useState<Set<string>>(new Set());

  const toggle = (id: string) => {
    setOpenIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  return (
    <article className="rewards-qa-content">
      <Link to={rewardsPath} className="rewards-qa-content__back">
        <FontAwesomeIcon icon={faArrowLeft} className="rewards-qa-content__back-icon" />
        <FormattedMessage id="rewardsLearn.backToRewards" />
      </Link>

      <RewardsHero accountName={accountName} />

      <h1 className="rewards-qa-content__title">
        <FormattedMessage id="rewardsQa.title" />
      </h1>

      <div className="rewards-qa-content__list">
        <div className="rewards-qa-content__item">
          <button
            type="button"
            className="rewards-qa-content__question-row"
            onClick={() => toggle('q1')}
            aria-expanded={openIds.has('q1')}
          >
            <span className="rewards-qa-content__question-text">
              <FormattedMessage id="rewardsQa.q1" />
            </span>
            <FontAwesomeIcon
              icon={openIds.has('q1') ? faChevronUp : faChevronDown}
              className="rewards-qa-content__chevron"
            />
          </button>
          {openIds.has('q1') && (
            <div className="rewards-qa-content__answer">
              <p><FormattedMessage id="rewardsQa.a1" /></p>
            </div>
          )}
        </div>

        <div className="rewards-qa-content__item">
          <button
            type="button"
            className="rewards-qa-content__question-row"
            onClick={() => toggle('q2')}
            aria-expanded={openIds.has('q2')}
          >
            <span className="rewards-qa-content__question-text">
              <FormattedMessage id="rewardsQa.q2" />
            </span>
            <FontAwesomeIcon
              icon={openIds.has('q2') ? faChevronUp : faChevronDown}
              className="rewards-qa-content__chevron"
            />
          </button>
          {openIds.has('q2') && (
            <div className="rewards-qa-content__answer">
              <p><FormattedMessage id="rewardsQa.a2" /></p>
            </div>
          )}
        </div>

        <div className="rewards-qa-content__item">
          <button
            type="button"
            className="rewards-qa-content__question-row"
            onClick={() => toggle('q3')}
            aria-expanded={openIds.has('q3')}
          >
            <span className="rewards-qa-content__question-text">
              <FormattedMessage id="rewardsQa.q3" />
            </span>
            <FontAwesomeIcon
              icon={openIds.has('q3') ? faChevronUp : faChevronDown}
              className="rewards-qa-content__chevron"
            />
          </button>
          {openIds.has('q3') && (
            <div className="rewards-qa-content__answer">
              <p><FormattedMessage id="rewardsQa.a3" /></p>
            </div>
          )}
        </div>

        <div className="rewards-qa-content__item">
          <button
            type="button"
            className="rewards-qa-content__question-row"
            onClick={() => toggle('q4')}
            aria-expanded={openIds.has('q4')}
          >
            <span className="rewards-qa-content__question-text">
              <FormattedMessage id="rewardsQa.q4" />
            </span>
            <FontAwesomeIcon
              icon={openIds.has('q4') ? faChevronUp : faChevronDown}
              className="rewards-qa-content__chevron"
            />
          </button>
          {openIds.has('q4') && (
            <div className="rewards-qa-content__answer">
              <p><FormattedMessage id="rewardsQa.a4" /></p>
            </div>
          )}
        </div>

        <div className="rewards-qa-content__item">
          <button
            type="button"
            className="rewards-qa-content__question-row"
            onClick={() => toggle('q5')}
            aria-expanded={openIds.has('q5')}
          >
            <span className="rewards-qa-content__question-text">
              <FormattedMessage id="rewardsQa.q5" />
            </span>
            <FontAwesomeIcon
              icon={openIds.has('q5') ? faChevronUp : faChevronDown}
              className="rewards-qa-content__chevron"
            />
          </button>
          {openIds.has('q5') && (
            <div className="rewards-qa-content__answer">
              <p><FormattedMessage id="rewardsQa.a5Intro" /></p>
              <ul className="rewards-qa-content__answer-list">
                <li><FormattedMessage id="rewardsQa.a5Step1" /></li>
                <li><FormattedMessage id="rewardsQa.a5Step2" /></li>
                <li><FormattedMessage id="rewardsQa.a5Step3" /></li>
                <li><FormattedMessage id="rewardsQa.a5Step4" /></li>
              </ul>
              <p><FormattedMessage id="rewardsQa.a5Note" /></p>
            </div>
          )}
        </div>

        <div className="rewards-qa-content__item">
          <button
            type="button"
            className="rewards-qa-content__question-row"
            onClick={() => toggle('q6')}
            aria-expanded={openIds.has('q6')}
          >
            <span className="rewards-qa-content__question-text">
              <FormattedMessage id="rewardsQa.q6" />
            </span>
            <FontAwesomeIcon
              icon={openIds.has('q6') ? faChevronUp : faChevronDown}
              className="rewards-qa-content__chevron"
            />
          </button>
          {openIds.has('q6') && (
            <div className="rewards-qa-content__answer">
              <p><FormattedMessage id="rewardsQa.a6" /></p>
            </div>
          )}
        </div>

        <div className="rewards-qa-content__item">
          <button
            type="button"
            className="rewards-qa-content__question-row"
            onClick={() => toggle('q7')}
            aria-expanded={openIds.has('q7')}
          >
            <span className="rewards-qa-content__question-text">
              <FormattedMessage id="rewardsQa.q7" />
            </span>
            <FontAwesomeIcon
              icon={openIds.has('q7') ? faChevronUp : faChevronDown}
              className="rewards-qa-content__chevron"
            />
          </button>
          {openIds.has('q7') && (
            <div className="rewards-qa-content__answer">
              <p><FormattedMessage id="rewardsQa.a7" /></p>
            </div>
          )}
        </div>

        <div className="rewards-qa-content__item">
          <button
            type="button"
            className="rewards-qa-content__question-row"
            onClick={() => toggle('q8')}
            aria-expanded={openIds.has('q8')}
          >
            <span className="rewards-qa-content__question-text">
              <FormattedMessage id="rewardsQa.q8" />
            </span>
            <FontAwesomeIcon
              icon={openIds.has('q8') ? faChevronUp : faChevronDown}
              className="rewards-qa-content__chevron"
            />
          </button>
          {openIds.has('q8') && (
            <div className="rewards-qa-content__answer">
              <p><FormattedMessage id="rewardsQa.a8" /></p>
            </div>
          )}
        </div>

        <div className="rewards-qa-content__item">
          <button
            type="button"
            className="rewards-qa-content__question-row"
            onClick={() => toggle('q9')}
            aria-expanded={openIds.has('q9')}
          >
            <span className="rewards-qa-content__question-text">
              <FormattedMessage id="rewardsQa.q9" />
            </span>
            <FontAwesomeIcon
              icon={openIds.has('q9') ? faChevronUp : faChevronDown}
              className="rewards-qa-content__chevron"
            />
          </button>
          {openIds.has('q9') && (
            <div className="rewards-qa-content__answer">
              <p><FormattedMessage id="rewardsQa.a9" /></p>
            </div>
          )}
        </div>

        <div className="rewards-qa-content__item">
          <button
            type="button"
            className="rewards-qa-content__question-row"
            onClick={() => toggle('q10')}
            aria-expanded={openIds.has('q10')}
          >
            <span className="rewards-qa-content__question-text">
              <FormattedMessage id="rewardsQa.q10" />
            </span>
            <FontAwesomeIcon
              icon={openIds.has('q10') ? faChevronUp : faChevronDown}
              className="rewards-qa-content__chevron"
            />
          </button>
          {openIds.has('q10') && (
            <div className="rewards-qa-content__answer">
              <p><FormattedMessage id="rewardsQa.a10" /></p>
            </div>
          )}
        </div>
      </div>
    </article>
  );
}
